import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useMemo, useReducer, useRef } from 'react';
import { useWeb5Context } from "../../../lib/Web5Context";
let initialState = {
  filters: {},
  operators: {},
  crossFilters: {},
  crossOperators: {},
  visibleFilters: [],
  openFilters: {},
  openQuickFilters: {},
  quickFilters: []
};
const defaultfiltersControl = {
  filters: {},
  operators: {},
  crossFilters: {},
  crossOperators: {}
};
const reducer = (state, action) => {
  switch (action.type) {
    case 'INIT':
      return _objectSpread(_objectSpread({}, state), {}, {
        filters: action.filters || initialState.filters,
        crossFilters: action.crossFilters || initialState.crossFilters,
        operators: action.operators || initialState.operators,
        crossOperators: action.crossOperators || initialState.crossOperators,
        visibleFilters: action.visibleFilters || initialState.visibleFilters,
        openFilters: action.openFilters || initialState.openFilters,
        openQuickFilters: action.openQuickFilters || initialState.openQuickFilters,
        quickFilters: action.quickFilters || initialState.quickFilters
      });
    case 'CHANGE_FILTER':
      return _objectSpread(_objectSpread({}, state), {}, {
        filters: action.filters
      });
    case 'CHANGE_CROSS_FILTER':
      return _objectSpread(_objectSpread({}, state), {}, {
        crossFilters: _objectSpread(_objectSpread({}, state.crossFilters), {}, {
          [action.crossEntity]: action.filters
        })
      });
    case 'CHANGE_OPERATORS':
      return _objectSpread(_objectSpread({}, state), {}, {
        operators: action.operators
      });
    case 'CHANGE_FILTER_AND_OPERATOR':
      return _objectSpread(_objectSpread({}, state), {}, {
        filters: action.filters,
        operators: action.operators
      });
    case 'CHANGE_CROSS_OPERATORS':
      return _objectSpread(_objectSpread({}, state), {}, {
        crossOperators: _objectSpread(_objectSpread({}, state.crossOperators), {}, {
          [action.crossEntity]: action.operators
        })
      });
    case 'CHANGE_CROSS_FILTER_AND_CROSS_OPERATOR':
      return _objectSpread(_objectSpread({}, state), {}, {
        crossFilters: _objectSpread(_objectSpread({}, state.crossFilters), {}, {
          [action.crossEntity]: action.filters
        }),
        crossOperators: _objectSpread(_objectSpread({}, state.crossOperators), {}, {
          [action.crossEntity]: action.operators
        })
      });
    case 'CLEAR_ALL':
      return _objectSpread(_objectSpread({}, state), {}, {
        filters: {},
        operators: {},
        crossFilters: {},
        crossOperators: {}
      });
    case 'HARD_RESET':
      return _objectSpread({}, initialState);
    case 'UPDATE_CONFIG':
    default:
      return _objectSpread(_objectSpread({}, state), {}, {
        visibleFilters: action.hasOwnProperty('visibleFilters') ? action.visibleFilters : state.visibleFilters,
        openFilters: action.hasOwnProperty('openFilters') ? action.openFilters : state.openFilters,
        openQuickFilters: action.hasOwnProperty('openQuickFilters') ? action.openQuickFilters : state.openQuickFilters,
        quickFilters: action.hasOwnProperty('quickFilters') ? action.quickFilters : state.quickFilters
      });
  }
};

// This allows to handle filters being independent from the normal storage
const useForceBIFilters = _ref => {
  let {
    defaultCache,
    afterOnChange,
    afterOnChangeCache,
    constants,
    isDashboard
  } = _ref;
  const {
    entities
  } = useWeb5Context();
  const [state, dispatch] = useReducer(reducer, _objectSpread(_objectSpread({}, initialState), defaultCache || {}));
  const hasBeenInitialized = useRef(false);
  const filtersControlRef = useRef(_objectSpread({}, defaultfiltersControl));
  const initFiltersRefs = useCallback(_ref2 => {
    let {
      filters,
      operators,
      crossFilters,
      crossOperators
    } = _ref2;
    if (filters) filtersControlRef.current.filters = filters;
    if (operators) filtersControlRef.current.operators = operators;
    if (crossFilters) filtersControlRef.current.crossFilters = crossFilters;
    if (crossOperators) filtersControlRef.current.crossOperators = crossOperators;
  }, []);
  const updateFiltersRefs = useCallback(_ref3 => {
    let {
      filters,
      operators,
      crossEntity,
      isAPurge
    } = _ref3;
    if (isAPurge) {
      filtersControlRef.current = _objectSpread({}, defaultfiltersControl);
    }
    if (!!crossEntity) {
      if (filters) {
        filtersControlRef.current = _objectSpread(_objectSpread({}, filtersControlRef.current), {}, {
          crossFilters: _objectSpread(_objectSpread({}, filtersControlRef.current.crossFilters), {}, {
            [crossEntity]: filters
          })
        });
      }
      if (operators) {
        filtersControlRef.current = _objectSpread(_objectSpread({}, filtersControlRef.current), {}, {
          crossOperators: _objectSpread(_objectSpread({}, filtersControlRef.current.crossOperators), {}, {
            [crossEntity]: operators
          })
        });
      }
    } else {
      filtersControlRef.current = _objectSpread(_objectSpread({}, filtersControlRef.current), {}, {
        filters: filters ? filters : filtersControlRef.current.filters,
        operators: operators ? operators : filtersControlRef.current.operators
      });
    }
  }, []);
  const dispatchFilters = useCallback(_ref4 => {
    let {
      type,
      filters,
      operators,
      crossEntity,
      isAPurge
    } = _ref4;
    if (isAPurge) {
      updateFiltersRefs({
        isAPurge
      });
      dispatch({
        type
      });
      return;
    }
    updateFiltersRefs({
      filters,
      operators,
      crossEntity
    });
    dispatch({
      type,
      filters,
      operators,
      crossEntity
    });
  }, [updateFiltersRefs]);
  const reset = useCallback(() => {
    dispatch({
      type: 'HARD_RESET'
    });
    initFiltersRefs(_objectSpread({}, defaultfiltersControl));
    hasBeenInitialized.current = false;
  }, [initFiltersRefs]);
  const init = useCallback(_ref5 => {
    let {
      filters,
      operators,
      crossFilters,
      crossOperators,
      visibleFilters,
      openFilters,
      openQuickFilters,
      quickFilters
    } = _ref5;
    if (hasBeenInitialized !== null && hasBeenInitialized !== void 0 && hasBeenInitialized.current) return;
    hasBeenInitialized.current = true;
    initFiltersRefs({
      filters,
      operators,
      crossFilters,
      crossOperators
    });
    dispatch({
      type: 'INIT',
      filters,
      operators,
      crossFilters,
      crossOperators,
      visibleFilters,
      openFilters,
      openQuickFilters,
      quickFilters
    });
  }, [initFiltersRefs]);
  const handleAfterOnChange = useCallback(_ref6 => {
    let {
      newFilters,
      newOperators,
      crossEntity,
      isAPurge
    } = _ref6;
    if (afterOnChange) {
      let uiFilters = {};
      if (isAPurge) {
        uiFilters = {
          filters: {},
          crossFilters: {},
          operators: {},
          crossOperators: {}
        };
        afterOnChange(uiFilters);
        return;
      }
      const filtersControl = filtersControlRef.current;
      if (newFilters || newOperators) {
        if (!!crossEntity) {
          if (newFilters && newOperators) {
            uiFilters = {
              filters: filtersControl.filters,
              crossFilters: _objectSpread(_objectSpread({}, filtersControl.crossFilters), {}, {
                [crossEntity]: newFilters
              }),
              operators: filtersControl.operators,
              crossOperators: _objectSpread(_objectSpread({}, filtersControl.crossOperators), {}, {
                [crossEntity]: newOperators
              })
            };
          } else if (newFilters && !newOperators) {
            uiFilters = {
              filters: filtersControl.filters,
              crossFilters: _objectSpread(_objectSpread({}, filtersControl.crossFilters), {}, {
                [crossEntity]: newFilters
              }),
              operators: filtersControl.operators,
              crossOperators: filtersControl.crossOperators
            };
          } else if (!newFilters && newOperators) {
            uiFilters = {
              filters: filtersControl.filters,
              crossFilters: filtersControl.crossFilters,
              operators: filtersControl.operators,
              crossOperators: _objectSpread(_objectSpread({}, filtersControl.crossOperators), {}, {
                [crossEntity]: newOperators
              })
            };
          }
        } else {
          if (newFilters && newOperators) {
            uiFilters = {
              filters: newFilters,
              crossFilters: filtersControl.crossFilters,
              operators: newOperators,
              crossOperators: filtersControl.crossOperators
            };
          } else if (newFilters && !newOperators) {
            uiFilters = {
              filters: newFilters,
              crossFilters: filtersControl.crossFilters,
              operators: filtersControl.operators,
              crossOperators: filtersControl.crossOperators
            };
          } else if (!newFilters && newOperators) {
            uiFilters = {
              filters: filtersControl.filters,
              crossFilters: filtersControl.crossFilters,
              operators: newOperators,
              crossOperators: filtersControl.crossOperators
            };
          }
        }
      } else {
        uiFilters = {
          filters: {},
          crossFilters: {},
          operators: {},
          crossOperators: {}
        };
      }
      afterOnChange(uiFilters);
    }
  }, [afterOnChange]);
  const handleWhileOnChange = useCallback(_ref7 => {
    let {
      filter,
      value,
      filters,
      crossEntity
    } = _ref7;
    const {
      ACTIVITIES
    } = entities;
    let newFilters = _objectSpread({}, filters);
    if (crossEntity === ACTIVITIES.entity) {
      const activitiesConstants = constants[ACTIVITIES.entity];
      const {
        mappedActivityTypeIdsReverse
      } = activitiesConstants;
      const filterId = filter.id;
      const subFilters = ['listCheckInType', 'fastCheckIn', 'opportunityCheckIn', 'callType', 'videoCallCheckInType', 'videoCallType', 'type', 'email', 'whatsappType'];
      if (filterId !== 'activityType') return newFilters;

      // if (
      //     (newFilters?.isSuspiciousCheckIn && !newFilters?.activityType) ||
      //     (!newFilters.activityType?.value?.includes(
      //         activityTypes.ACTIVITY_TYPE_CHECKIN.toString(),
      //     ) &&
      //         !newFilters.activityType?.value?.includes(
      //             activityTypes.ACTIVITY_TYPE_OPPORTUNITY_CHECKIN.toString(),
      //         ))
      // ) {
      //     // When there is isSuspiciousCheckIn filter and there are no CheckIn and
      //     // OpportunityCheckIn filters, remove isSuspiciousCheckIn filter
      //     delete newFilters.isSuspiciousCheckIn;
      // }

      const activeSubFilters = Object.keys(newFilters).reduce((arr, key) => {
        if (subFilters.includes(key)) arr.push(key);
        return arr;
      }, []);
      if (activeSubFilters.length) {
        if (!value || !(value !== null && value !== void 0 && value.length)) {
          newFilters = Object.entries(newFilters).reduce((obj, _ref8) => {
            let [key, value] = _ref8;
            if (!subFilters.includes(key)) obj[key] = value;
            return obj;
          }, {});
        } else {
          const activityTypeValues = value || [];
          const subFiltersToRemove = activeSubFilters.reduce((arr, current) => {
            const filterId = mappedActivityTypeIdsReverse[current];
            if (!activityTypeValues.includes(filterId.toString())) {
              arr.push(current);
            }
            return arr;
          }, []);
          newFilters = Object.entries(newFilters).reduce((obj, _ref9) => {
            let [key, value] = _ref9;
            if (!subFiltersToRemove.includes(key)) obj[key] = value;
            return obj;
          }, {});
        }
      }
    }
    return newFilters;
  }, [entities, constants]);
  const customChangeFilter = useCallback(_ref10 => {
    var _crossFilters$crossEn, _filters;
    let {
      filter,
      value,
      completeValues = null,
      crossEntity
    } = _ref10;
    let newFilters;
    // use filtersControlRef because when triggering change filters sequentially the state has no time
    // to update and then we loose data. filtersControlRef is always updated
    let filters = filtersControlRef.current.filters;
    let crossFilters = filtersControlRef.current.crossFilters;
    filters = crossEntity ? (_crossFilters$crossEn = crossFilters === null || crossFilters === void 0 ? void 0 : crossFilters[crossEntity]) !== null && _crossFilters$crossEn !== void 0 ? _crossFilters$crossEn : {} : (_filters = filters) !== null && _filters !== void 0 ? _filters : {};
    if (!value || value.length === 0 || value === '' || value.hasOwnProperty('from') && !value.from && !value.to) {
      const _filter$id = filter.id,
        {
          [_filter$id]: value
        } = filters,
        newFiltersRest = _objectWithoutProperties(filters, [_filter$id].map(_toPropertyKey));
      newFilters = newFiltersRest;
      if (filter.hasOwnProperty('extraFilterProps')) {
        const _filter$extraFilterPr = filter.extraFilterProps.id,
          {
            [_filter$extraFilterPr]: value
          } = newFilters,
          newFiltersWithoutExtra = _objectWithoutProperties(newFilters, [_filter$extraFilterPr].map(_toPropertyKey));
        newFilters = newFiltersWithoutExtra;
      }
    } else {
      if (filter !== null && filter !== void 0 && filter.isCustomRange) {
        newFilters = _objectSpread(_objectSpread({}, filters), {}, {
          [filter.id]: _objectSpread({
            value,
            label: completeValues.label,
            completeValues
          }, filter)
        });
      } else {
        newFilters = _objectSpread(_objectSpread({}, filters), {}, {
          [filter.id]: _objectSpread({
            value,
            completeValues
          }, filter)
        });
      }
    }
    newFilters = handleWhileOnChange({
      filter,
      value,
      filters: newFilters,
      crossEntity
    });
    if (!!crossEntity) {
      dispatchFilters({
        type: 'CHANGE_CROSS_FILTER',
        filters: newFilters,
        crossEntity
      });
    } else {
      dispatchFilters({
        type: 'CHANGE_FILTER',
        filters: newFilters
      });
    }
    handleAfterOnChange({
      newFilters,
      crossEntity
    });
  }, [handleAfterOnChange, handleWhileOnChange, dispatchFilters]);
  const customChangeOperator = useCallback(_ref11 => {
    let {
      operators,
      crossEntity
    } = _ref11;
    if (!!crossEntity) {
      dispatchFilters({
        type: 'CHANGE_CROSS_OPERATORS',
        operators,
        crossEntity: crossEntity.entity || crossEntity
      });
    } else {
      dispatchFilters({
        type: 'CHANGE_OPERATORS',
        operators
      });
    }
    handleAfterOnChange({
      newOperators: operators,
      crossEntity
    });
  }, [handleAfterOnChange, dispatchFilters]);
  const customDeleteMultipleFilters = useCallback(_ref12 => {
    let {
      entity,
      filters
    } = _ref12;
    const name = entity.entity;
    const {
      filters: oldFilters = {},
      operators: oldOperators = {},
      crossFilters: oldCrossFilters = {},
      crossOperators: oldCrossOperators = {}
    } = state;
    const isCrossFilters = !Array.isArray(filters);
    const deleteFilters = (filtersArr, filters, operators) => {
      const newFilters = Object.keys(filters).reduce((obj, key) => {
        if (!filtersArr.includes(key)) obj[key] = filters[key];
        return obj;
      }, {});
      const newOperators = Object.keys(operators).reduce((obj, key) => {
        if (!filtersArr.includes(key)) obj[key] = operators[key];
        return obj;
      }, {});
      return {
        newFilters,
        newOperators
      };
    };
    const processFilters = (filtersArr, currentFilters, currentOperators, crossEntity) => {
      const {
        newFilters,
        newOperators
      } = deleteFilters(filtersArr, currentFilters, currentOperators);
      if (!!crossEntity) {
        dispatchFilters({
          type: 'CHANGE_CROSS_FILTER_AND_CROSS_OPERATOR',
          filters: newFilters,
          operators: newOperators,
          crossEntity
        });
      } else {
        dispatchFilters({
          type: 'CHANGE_FILTER_AND_OPERATOR',
          filters: newFilters,
          operators: newOperators
        });
      }
      handleAfterOnChange({
        newFilters,
        newOperators,
        crossEntity
      });
    };
    if (isCrossFilters) {
      for (const [crossEntity, crossEntityFilters] of Object.entries(filters)) {
        const isCrossEntity = name !== crossEntity;
        const currentFilters = isCrossEntity ? oldCrossFilters[crossEntity] || {} : oldFilters;
        const currentOperators = isCrossEntity ? oldCrossOperators[crossEntity] || {} : oldOperators;
        processFilters(crossEntityFilters, currentFilters, currentOperators, isCrossEntity ? crossEntity : null);
      }
    } else {
      if (filters.length === 0) return;
      processFilters(filters, oldFilters, oldOperators);
    }
  }, [state, handleAfterOnChange, dispatchFilters]);
  const customClearFilters = useCallback(() => {
    dispatchFilters({
      type: 'CLEAR_ALL',
      isAPurge: true
    });
    handleAfterOnChange({
      isAPurge: true
    });
  }, [handleAfterOnChange, dispatchFilters]);
  const customSaveCache = useCallback(function (newCache) {
    if (newCache === void 0) {
      newCache = {};
    }
    const compareFields = ['visibleFilters', 'openFilters', 'openQuickFilters', 'quickFilters'];
    const payload = compareFields.reduce((obj, field) => {
      obj[field] = newCache[field] || state[field];
      return obj;
    }, {});
    const oldVisibleFilters = [...state.visibleFilters];
    dispatch(_objectSpread({
      type: 'UPDATE_CONFIG'
    }, payload));
    afterOnChangeCache && afterOnChangeCache({
      visibleFilters: payload.visibleFilters,
      oldVisibleFilters
    });
  }, [state, afterOnChangeCache]);
  const hasFilters = useMemo(() => {
    var _Object$keys;
    return ((_Object$keys = Object.keys(state.filters)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0;
  }, [state.filters]);
  const hasOperators = useMemo(() => {
    var _Object$keys2;
    return ((_Object$keys2 = Object.keys(state.operators)) === null || _Object$keys2 === void 0 ? void 0 : _Object$keys2.length) > 0;
  }, [state.operators]);
  const hasCrossFilters = useMemo(() => {
    return Object.entries(state.crossFilters).some(_ref13 => {
      let [key, value] = _ref13;
      return Object.keys(value).length > 0;
    });
  }, [state.crossFilters]);
  const hasCrossOperators = useMemo(() => {
    return Object.entries(state.crossOperators).some(_ref14 => {
      let [key, value] = _ref14;
      return Object.keys(value).length > 0;
    });
  }, [state.crossOperators]);
  const hasActiveFilters = useMemo(() => {
    return hasFilters || hasOperators || hasCrossFilters || hasCrossOperators;
  }, [hasFilters, hasOperators, hasCrossFilters, hasCrossOperators]);

  // WIP allow isSuspiciousCheckIn filter
  // const customIsSuspiciousCheckInOnClick = useCallback(() => {
  //     const { ACTIVITIES } = entities;
  //     const crossFilters = state.crossFilters;
  //     const entityCrossFilters = crossFilters?.[ACTIVITIES.entity] || {};
  //     const isSuspiciousCheckIn = entityCrossFilters?.isSuspiciousCheckIn || {};

  //     if (isSuspiciousCheckIn?.value) {
  //         customChangeFilter({
  //             filter: { id: 'isSuspiciousCheckIn' },
  //             value: 1,
  //             completeValues: 1,
  //             crossEntity: ACTIVITIES.entity,
  //         });
  //     } else {
  //         customChangeFilter({
  //             filter: { id: 'isSuspiciousCheckIn' },
  //             value: 0,
  //             completeValues: 0,
  //             crossEntity: ACTIVITIES.entity,
  //         });
  //     }
  // }, [state.crossFilters, customChangeFilter, entities]);

  const treatSchema = useCallback(_ref15 => {
    let {
      schema,
      entity
    } = _ref15;
    // In ForceBI the principal filter is always ACCOUNTS the rest are cross filters
    // When is sent to backend, all filters are sent grouped by entity without the principal entity
    const filtersToIgnore = ['onlySelected', 'idCampaign'];
    const {
      ACTIVITIES
    } = entities;
    const crossFiltersToIgnore = {
      [ACTIVITIES.entity]: ['customActivities', 'FollowingItem', 'pendingConversations', 'subject']
    };
    const finalSchema = schema.reduce((arr, current) => {
      var _crossFiltersToIgnore, _filter$inputAttrs;
      if (filtersToIgnore.includes(current.id)) return arr;
      if (entity && crossFiltersToIgnore !== null && crossFiltersToIgnore !== void 0 && (_crossFiltersToIgnore = crossFiltersToIgnore[entity]) !== null && _crossFiltersToIgnore !== void 0 && _crossFiltersToIgnore.includes(current.id)) return arr;
      const filter = _objectSpread({}, current);
      // We don't need this isFakeCrossFilter prop. ForceBI Backend accepts those filters like they are, without transformations.
      if (filter.isFakeCrossFilter) filter.isFakeCrossFilter = false;
      filter.isRemovable = true;
      filter.isPinnable = false;
      if (filter !== null && filter !== void 0 && (_filter$inputAttrs = filter.inputAttrs) !== null && _filter$inputAttrs !== void 0 && _filter$inputAttrs.actions) {
        //Hide isSuspiciousCheckIn filter until its implemented
        delete filter.inputAttrs.actions;
        // WIP allow isSuspiciousCheckIn filter
        // filter.inputAttrs?.actions.forEach((current) => {
        //     if (current.id === 'isSuspiciousCheckIn') {
        //         current.onClick = customIsSuspiciousCheckInOnClick;
        //     }
        // });
      }
      arr.push(filter);
      return arr;
    }, []);
    return finalSchema;
  }, [entities]);
  const treatExtraSchema = useCallback(_ref16 => {
    let {
      tabs,
      entity
    } = _ref16;
    const finalTabs = tabs.map(tab => {
      const newFields = tab.fields.reduce((arr, field) => {
        const newField = _objectSpread({}, field);
        newField.isRemovable = true;
        newField.isPinnable = false;
        arr.push(newField);
        return arr;
      }, []);
      return _objectSpread(_objectSpread({}, tab), {}, {
        fields: newFields
      });
    });
    return finalTabs;
  }, []);
  const beforeSchema = useCallback(schema => {
    return treatSchema({
      schema
    });
  }, [treatSchema]);
  const beforeExtraSchema = useCallback(tabs => {
    return treatExtraSchema({
      tabs
    });
  }, [treatExtraSchema]);
  const beforeCrossSchema = useCallback(_ref17 => {
    let {
      schema,
      entity
    } = _ref17;
    return treatSchema({
      schema,
      entity
    });
  }, [treatSchema]);
  const beforeCrossExtraSchema = useCallback(_ref18 => {
    let {
      tabs,
      entity
    } = _ref18;
    return treatExtraSchema({
      tabs,
      entity
    });
  }, [treatExtraSchema]);
  const customGetSubFilterParentValue = useCallback(filter => {
    var _filter$completeValue;
    if (filter !== null && filter !== void 0 && (_filter$completeValue = filter.completeValues) !== null && _filter$completeValue !== void 0 && _filter$completeValue.length) {
      var _filter$completeValue2;
      return filter === null || filter === void 0 ? void 0 : (_filter$completeValue2 = filter.completeValues[0]) === null || _filter$completeValue2 === void 0 ? void 0 : _filter$completeValue2.value;
    }
    return null;
  }, []);
  return {
    // This prop is key to make NewEntityFilters avoid normal storage (cache and store)
    // The following methods take control of the storage that will be handled from this hook
    avoidStorage: true,
    customChangeFilter,
    customDeleteMultipleFilters,
    customClearFilters,
    customChangeOperator,
    customSaveCache,
    customGetSubFilterParentValue,
    init,
    reset,
    beforeSchema,
    beforeExtraSchema,
    beforeCrossSchema,
    beforeCrossExtraSchema,
    hasActiveFilters,
    filters: state.filters,
    operators: state.operators,
    crossFilters: state.crossFilters,
    crossOperators: state.crossOperators,
    customCache: {
      visibleFilters: state.visibleFilters,
      openFilters: state.openFilters,
      openQuickFilters: state.openQuickFilters,
      quickFilters: state.quickFilters
    }
  };
};
export default useForceBIFilters;